import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rl-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  imports: [MatIconModule, CommonModule, TranslateModule],
})
export class ButtonComponent {
  @Input() text?: string;
  @Input() type: 'primary' | 'silent' | 'secondary' | 'destructive' = 'primary';
  @Input() icon?: string;
  @Input() filteredState?: boolean;
  @Input() img?: string;
  @Input() disabled?: boolean;
  @Input() options?: ButtonOptions[] = [];
  @Output() buttonClickEvent = new EventEmitter<void>();
  @Output() optionButtonClicked = new EventEmitter<ButtonOptions>();

  @HostListener('document:click', ['$event'])
  onWindowClick() {
    if (this.dropDownOpen) this.dropDownOpen = false;
  }
  buttonState = ButtonState;
  dropDownOpen = false;
  buttonClicked() {
    this.buttonClickEvent.emit();
  }
  optionClicked(option: ButtonOptions) {
    this.optionButtonClicked.emit(option);
  }
  showDropdown($event: any) {
    this.dropDownOpen = !this.dropDownOpen;
    $event.stopPropagation();
  }
}
export interface ButtonOptions {
  label: string;
  icon?: string;
  img?: string;
}
export enum ButtonState {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SILENT = 'silent',
  DESTRUCTIVE = 'destructive',
}
